export default class loginValidationCtrl {
	constructor($scope, $http, $state, ngNotify, LOCAL_ENV_CONSTANT, $localStorage) {
		const localenv = require('../../local.env.json')
		const clientName = localenv.clientName;

		$scope.clientLogo = require('../assets/images/logo-' + clientName + '.png')

		if(typeof $localStorage.userLogin !== 'undefined'){
			$state.go('app.home',{},{reload:'app.home'})
		}

		$scope.submitForm = function(isValid) {
			if (isValid) {
				const email = $scope.loginForm.name.$$rawModelValue
				const pass = $scope.loginForm.password.$$rawModelValue
				const param = { username:email, pass:pass, type:'WEB' }

				$http({
					method  : 'POST',
					url     : LOCAL_ENV_CONSTANT.USER_API_URL +'/api/v1/parvulo-api/users',
					data    : $.param(param),
					headers:  {
						'Content-Type' : 'application/x-www-form-urlencoded',
					}
				})
				.success(function(result) {
					const data = JSON.parse(decodeURIComponent(atob(result.results).split('').map(function(c) {
							return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
								}).join('')))
					
					if (data.status == 1) {
						$localStorage.userLogin = data
						window.location = LOCAL_ENV_CONSTANT.HOMEPAGE
					} else {
						ngNotify.set('El usuario no existe en nuestro sistema.','error')
						delete $localStorage.userLogin;
					}
				})
			}else{
				ngNotify.set('Error de comunicación con el servidor','error')
				delete $localStorage.userLogin
			}
		};
	}
}

loginValidationCtrl.$inject = ['$scope', '$http', '$state', 'ngNotify', 'LOCAL_ENV_CONSTANT', '$localStorage'];



// WEBPACK FOOTER //
// ./src/login/loginValidationCtrl.js